import React from "react";
import { useSelector } from "react-redux";
import { Placeholder } from "semantic-ui-react";
import CustomLine from "./customLine";

const LoadingReward = ({
  commonLoading,
  children,
  className,
  mapIndex = 2,
}) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);

  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  return commonLoading || loadingStatus
    ? Array.from({ length: mapIndex }, (_, i) => i).map((item) => {
        return (
          <Placeholder
            inverted={isDarkMode}
            className={`${className} h-[195px] rounded-xl !mt-0 mb-[10px] p-[12px] flex items-center justify-between`}
          >
            <div className="flex flex-col justify-between items-start  h-full w-full">
              <CustomLine className={`w-[250px] h-[25px]`} />
              <CustomLine className={`w-[150px] h-[15px]`} />
              <CustomLine className={`w-[100px] h-[10px]`} />
              <CustomLine className={`w-[130px] h-[15px]`} />
              <CustomLine className={`w-full h-[45px]`} />
            </div>
          </Placeholder>
        );
      })
    : children;
};

export default LoadingReward;
